module.exports = __webpack_public_path__ + "img/jo1.a8d5a0a9.png";